import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AddToHomeScreenPromptStore {
  hasShownPrompt: boolean;
  isOpen: boolean;
  closePrompt: () => void;
  showPrompt: () => void;
}

export const useAddToHomeScreenPromptStore = create<AddToHomeScreenPromptStore>()(
  persist(
    (set, get) => ({
      hasShownPrompt: false,
      isOpen: false,

      closePrompt: () => set({ isOpen: false }),

      showPrompt: () => {
        if (get().hasShownPrompt) return;

        set({
          hasShownPrompt: true,
          isOpen: true,
        });
      },
    }),
    {
      name: "sravni-dohod-add-to-home-screen-prompt-v1",
    }
  )
);
